import { HttpContextToken } from '@angular/common/http';

/**
 * When set to `true` on a request's HttpContext, the global error interceptor
 * stays SILENT on a 403 response — it shows no error toast (and does not
 * redirect). Use this on calls that own their 403 handling: fail-closed "probe"
 * calls that swallow the 403 (e.g. the org BRSR-forms-enabled probe issued for
 * users without Organization.VIEW), or components with a contextual inline-error
 * UX (e.g. the BRSR autosave hint + toast). The error is still re-thrown so
 * local catchError handlers operate normally.
 *
 * ⚠ The user create/edit screen treats 403 as interceptor-owned and stays
 * silent on it (`INTERCEPTOR_OWNED_STATUSES` in `user.component.ts`) — a future
 * user-path caller setting this token would make BOTH sides silent on 403.
 */
export const BYPASS_FORBIDDEN_REDIRECT = new HttpContextToken<boolean>(
  () => false,
);

/**
 * When set to `true` on a request's HttpContext, the global error interceptor
 * stays SILENT on a 5xx response — it shows no generic "something went wrong"
 * toast. Use this only on calls that own their server-error UX end-to-end
 * (e.g. a contextual inline failure state with its own retry affordance). The
 * error is still re-thrown so local catchError handlers operate normally.
 *
 * ⚠ Same caution as above, for 5xx: screens relying on the Wave-5 ownership
 * boundary (`INTERCEPTOR_OWNED_STATUSES` in `user.component.ts`) deliberately
 * stay silent on 5xx because THIS toast surfaces it — a user-path caller
 * setting this token would make both sides silent again, which is exactly the
 * Bug-1 failure mode.
 */
export const BYPASS_SERVER_ERROR_TOAST = new HttpContextToken<boolean>(
  () => false,
);
